import { Component } from '@angular/core';

@Component({
    selector: 'app-no-data',
    templateUrl: './no-data.component.html',
    standalone: false
})
export class NoDataComponent {

}
